// extracted by mini-css-extract-plugin
export default {"infoWrapper":"style_infoWrapper__yGpkz","infoTitle":"style_infoTitle__AnrIW","infoText":"style_infoText__njx59","alertTitle":"style_alertTitle__easfV"};